import * as types from './actionTypes';

export function fetchUnitsListAggrRequest(payload) {
  return {
    type: types.FETCH_UNITS_LIST_AGGR_REQUEST,
    payload,
  };
}

export function fetchUnitsListAggrSuccess(payload) {
  return {
    type: types.FETCH_UNITS_LIST_AGGR_SUCCESS,
    payload,
  };
}

export function fetchUnitsListAggrFailure(payload) {
  return {
    type: types.FETCH_UNITS_LIST_AGGR_FAILURE,
    payload,
  };
}

export function resetUnitsListAggr() {
  return {
    type: types.RESET_UNITS_LIST_AGGR,
  };
}
